import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  signal,
  Type,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ModalRef} from './modal.ref';
import {MODAL_CONFIG} from '@shared/components/modal/modal.token';
import {ModalConfig} from '@shared/components/modal/modal.config';
import {LucideAngularModule, X} from '@shared/components/icons/google-icons';

@Component({
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  selector: 'app-modal',
  templateUrl: './modal.html',
})
export class Modal implements AfterViewInit {

  @Input() modalRef!: ModalRef;

  @ViewChild('content', { read: ViewContainerRef })
  content!: ViewContainerRef;

  title?: string;
  closeOnBackdrop = true;

  isVisible = signal(false);

  private config = inject<ModalConfig | null>(MODAL_CONFIG, { optional: true });

  childComponentType?: Type<any>;

  constructor(private cdr: ChangeDetectorRef) {
  }

  attachContentAfterViewInit() {
    if (this.content && this.childComponentType) {
      this.content.createComponent(this.childComponentType);
    }
  }

  ngAfterViewInit() {

    if (this.config) {
      this.title = this.config.title;
      this.closeOnBackdrop = this.config.closeOnBackdrop ?? true;

      this.cdr.detectChanges();
    }

    requestAnimationFrame(() => {
      this.isVisible.set(true);
      this.attachContentAfterViewInit();
    });
  }

  close(): void {
    this.isVisible.set(false);

    const ref = this.modalRef;
    if (!ref) return;

    setTimeout(() => ref.close(), 200);
  }

  onBackdropClick(): void {
    if (this.closeOnBackdrop) {
      this.close();
    }
  }

  protected readonly X = X;
}
